import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from './Button'
import { formatErrorMessage } from '../lib/error'

function PanelBase({
  title,
  description,
  actions,
}: {
  title: string
  description?: string
  actions?: React.ReactNode
}) {
  return (
    <section
      aria-label={title}
      className="rounded-lg border border-border bg-card p-6 shadow-sm"
    >
      <div className="grid gap-4">
        <div className="font-semibold">{title}</div>
        {description ? <div className="text-muted-foreground">{description}</div> : null}
        {actions ? <div className="mt-2">{actions}</div> : null}
      </div>
    </section>
  )
}

export const EmptyState = memo(function EmptyState(props: { label?: string }) {
  const { t } = useTranslation()
  return (
    <PanelBase
      title={t('common.noPosts', { defaultValue: 'No posts available' })}
      description={props.label}
    />
  )
})

export const ErrorState = memo(function ErrorState(props: {
  title?: string
  error?: unknown
  onRetry?: () => void
}) {
  const { t } = useTranslation()
  const message = formatErrorMessage(props.error)

  return (
    <PanelBase
      title={
        props.title ?? t('common.errorTitle', { defaultValue: 'Failed to load posts' })
      }
      description={message}
      actions={
        props.onRetry ? (
          <Button variant="primary" onClick={props.onRetry}>
            {t('common.retry')}
          </Button>
        ) : null
      }
    />
  )
})
